export const escapeHtml = (string) => string
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;');

export const capitalize = (value) => {
  if (typeof value !== 'string') {
    return value;
  }

  return value.charAt(0).toUpperCase() + value.slice(1);
};
